// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xrmW","type":"styles_type__2Orju","choices":"styles_choices__2BSTn"};